import React, {Component} from 'react';
import AccordionSection from './AccordionSection/AccordionSection';

export default class Accordion extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeSection: null,
        };

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(sectionId) {
        if(this.state.activeSection === sectionId) {
            this.setState({
                activeSection: null,
            });
        } else {
            this.setState({
                activeSection: sectionId,
            });
        }
    }

    render() {
        return (
            <div className="accordion">
                {
                    this.props.sections.map(section => {
                        return (
                            <AccordionSection isActive={this.state.activeSection === section.index}
                                                 index={section.index}
                                                 key={section.index}
                                                 handleClick={this.handleClick}
                                                 accordionTrigger={section.accordionTrigger}
                                                 accordionContent={section.accordionContent} />
                        );
                    })
                }
            </div>
        );
    }
}